export default [
  {
    displayText: 'Any',
    value: '', // TODO: use null rather than '' when queryGenerator is fixed
  }, {
    displayText: '1+',
    value: 1,
  }, {
    displayText: '2+',
    value: 2,
  }, {
    displayText: '3+',
    value: 3,
  }, {
    displayText: '4+',
    value: 4,
  }, {
    displayText: '5+',
    value: 5,
  }, {
    displayText: '6',
    value: 6,
  },
];
